import {useContext} from 'react';
import ConfirmDialogContext, {ConfirmDialogContextValue} from './ConfirmDialogContext';

export default function useConfirmDialogContext(): ConfirmDialogContextValue {
  return useContext(ConfirmDialogContext);
}
